export default __webpack_public_path__ + "static/media/userProfile.edae951b.svg";